import { render, staticRenderFns } from "./SaveBrowser.vue?vue&type=template&id=bcf67cc2"
import script from "./SaveBrowser.vue?vue&type=script&lang=js"
export * from "./SaveBrowser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports